import { IOrder, Order } from "@/entities/order/order";
import { IOrderHistory, OrderHistory } from "@/entities/order/orderHistory";
import getEndpoint from "@/utils/domain";
import { IOrderRepository } from "./order.types";
import axios from "axios";
import { createHeader } from "@/utils/createHeader";
import { API, graphqlOperation } from "aws-amplify";
import * as queires from "@/graphql/queries";

// export const ENDPOINT_PATH = getEndpoint("/api/order");
export const ENDPOINT_PATH =
    "https://hkf9vqpqe4.execute-api.ap-southeast-1.amazonaws.com/Prod";
export const GENERATE_ORDER_ID_ENDPOINT_PATH =
    "https://s8x6bqxwzi.execute-api.ap-southeast-1.amazonaws.com/Prod/gentele";
export class OrderAPIRepository implements IOrderRepository {
    async generateOrderId(branchId: string, idToken: string): Promise<string> {
        const response = (await axios.post(GENERATE_ORDER_ID_ENDPOINT_PATH, {
            branchId,
        })) as any;

        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);

        if (response.status === 200) {
            return response.data.orderId;
        } else {
            throw new Error("Failed to get orderID.");
        }
    }

    async generateOrderId3rdparty(branchId: string, group: string): Promise<string> {
        const response = await API.post("saletoolapi", "/generate-order-id", {
            body: {
                branch: branchId,
                group: group,
            }
        })
        
        console.log("generateOrderId3rdparty: ",response);
        
        return response.orderId;
    }

    async getOrder(orderId: string, idToken: string): Promise<IOrder> {
        const response = await axios.post(
            ENDPOINT_PATH + "/get",
            {
                orderId,
            },
            {
                headers: createHeader({ apikey: null, idToken }) as any,
            }
        );

        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);
        if (response.status === 200) {
            const o = response?.data as IOrder;
            return new Order(o);
        } else {
            throw new Error("Failed to get order.");
        }
    }

    async createOrder(order: IOrder, idToken: string): Promise<IOrder> {
        const body = JSON.stringify(order);
        const response = await axios.post(
            ENDPOINT_PATH + "/create",
            {
                ...order,
            },
            {
                headers: createHeader({ apikey: null, idToken }) as any,
            }
        );

        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);
        if (response.status === 200) {
            const o = response?.data as IOrder;
            return new Order(o);
        } else {
            throw new Error("Failed to create order.");
        }
    }

    async getOrderHistory(
        orderId: string,
        idToken: string
    ): Promise<IOrderHistory> {
        const body = JSON.stringify({ orderId: orderId });
        const response = (await axios.post(ENDPOINT_PATH + "/get", {
            body: body,
        })) as any;
        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);
        if (response.status === 200) {
            const o = response?.data as IOrderHistory;
            return new OrderHistory(o);
        } else {
            throw new Error("Failed to get order history.");
        }
    }

    async listOrderHistory(
        email: string,
        idToken: string
    ): Promise<IOrderHistory[]> {
        const body = JSON.stringify({ customerEmail: email });
        const response = (await axios.post(
            ENDPOINT_PATH.replace("order", "userhistory") + "/getEmail",
            {
                body: body,
            }
        )) as any;
        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);
        if (response.status === 200) {
            const o = response?.data as IOrderHistory[];
            const ordersHistory = o.map((order) => new OrderHistory(order));
            return ordersHistory;
        } else {
            throw new Error("Failed to get list order history.");
        }
    }

    async listOrder(userId: string, idToken: string): Promise<IOrder[]> {
        const body = JSON.stringify({ ownerId: userId });
        const response = (await axios.post(ENDPOINT_PATH + "/getUser", {
            body: body,
        })) as any;
        console.log(`status: ${response.status}`);
        console.log(`body: ${response.data}`);
        if (response.status === 200) {
            const o = response?.data as Order[];
            const orders = o.map((order) => new Order(order));
            return orders;
        } else {
            throw new Error("Failed to get list order.");
        }
    }

    async getPOSOrder(orderId: string): Promise<any> {
        const response = await API.get("saletoolapi", "/pos-order", {
            queryStringParameters: {
                orderId,
            },
        });
        return response;
    }
}
